import * as ACTIONS from 'constant/action/loader'
import { createAction } from 'redux-actions'

export const updateLoading = createAction(ACTIONS.UPDATE_LOADING)
